import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import TenantModal from './TenantModal';
import { useParams, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { useAuth } from '../../context/AuthContext';
import withPermission from '../../utils/withPermission';
import Swal from 'sweetalert2';
import TenantDetails from './TenantDetails';

const AllTenantList = () => {
    const [tenants, setTenants] = useState([]);
    const [instances, setInstances] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedTenantId, setSelectedTenantId] = useState(null);
    const [selectedTenantData, setSelectedTenantData] = useState(null);
    const [errors, setErrors] = useState({});
    const didFetchRef = useRef(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const { id } = useParams();
    const [industries, setIndustries] = useState([]);
    const { roles, permissions } = useAuth();
    const WithDeletePermission = withPermission(({ children }) => children, ['tenant-delete']);
    const WithEditPermission = withPermission(({ children }) => children, ['tenant-edit']);
    const WithCreatePermission = withPermission(({ children }) => children, ['tenant-create']);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const [statusFilter, setStatusFilter] = useState('all');
    useEffect(() => {
        if (!didFetchRef.current) {
            fetchInstances();
            // fetchIndustries();
            didFetchRef.current = true;
        }
    }, [currentPage]);
    const [accountStatus, setAccountStatus] = useState('all');
    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchTenants(1, accountStatus, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery, accountStatus]);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };

    const fetchInstances = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/instance-info`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            const data = response.data.Data || response.data.data || response.data || [];
            if (Array.isArray(data)) {
                setInstances(data);
            } else if (data && data.data) {
                setInstances(data.data);
            }
        } catch (error) {
            console.error('Error fetching instances:', error);
        }
    };

    const fetchTenants = async (page = 1, status = '', search = '') => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/tenants`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                params: {
                    page,
                    search: search || searchQuery,
                    account_status: status === 'all' ? undefined : status,

                },
            });
            console.log('Tenant Response:', response.data);
            const tenantData = response.data.Data;

            setTenants(tenantData);
            const totalPages = response.data.meta ? response.data.meta.total_pages : 1;
            setPageCount(totalPages);
            setCurrentPage(page);
        } catch (error) {
            console.error('Error fetching tenants:', error);
        }
    };

    const fetchIndustries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let allIndustries = [];



            const response = await axios.get(`${backendUrl}/api/industries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            allIndustries = [...allIndustries, ...response.data.industry];

            setIndustries(allIndustries);
        } catch (error) {
            console.error('Error fetching industries:', error);
        }
    };
    const addTenant = async (newTenant) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const instanceParam = newTenant.instance_id || id || '';
            const queryParam = instanceParam ? `?instance_id=${instanceParam}` : '';

            const response = await axios.post(`${backendUrl}/api/tenants${queryParam}`, newTenant, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const createdTenant = response.data?.Data?.[0] || response.data?.data?.[0] || response.data?.[0];

            if (createdTenant) {
                if (createdTenant.instance) {
                    createdTenant.setup_name = createdTenant.instance.setup_name;
                }
                setTenants((prevTenants) => [...prevTenants, createdTenant]);
            } else {
                console.error('Creation failed, no data returned.');
            }

            handleCloseModal();
            return {};
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            } else {
                console.error('Error adding tenant:', error);
            }
        }
    };

    const editTenant = async (tenantId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.put(`${backendUrl}/api/tenants/${tenantId}`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const updatedTenant = response.data?.Data || response.data?.data || response.data;

            if (updatedTenant) {
                if (updatedTenant.instance) {
                    updatedTenant.setup_name = updatedTenant.instance.setup_name;
                }

                setTenants((prevTenants) =>
                    prevTenants.map((tenant) =>
                        tenant.id === updatedTenant.id ? updatedTenant : tenant
                    )
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
            return {};
        } catch (error) {
            if (error.response && error.response.data?.errors) {
                return error.response.data?.errors;
            } else {
                console.error('Error updating tenant:', error);
            }
        }
    };

    const deleteTenant = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;

                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    await axios.delete(` ${backendUrl}/api/tenants/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    setTenants(tenants.filter(tenant => tenant.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The tenant has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting tenant:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete tenant. Please try again.",
                        "error"
                    );
                }
            }
        });
    };

    const handleShowModal = (tenantId = null) => {
        if (tenantId) {
            const tenantToEdit = tenants.find(tenant => tenant.id === tenantId);
            setSelectedTenantData(tenantToEdit || null); // Set data for editing
        } else {
            setSelectedTenantData(null); // Clear form data for creating new tenant
            setErrors({}); // Clear any errors
        }
        fetchInstances(); // Load instances for selection in both create and edit (from AllTenantList context)
        setSelectedTenantId(tenantId);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedTenantId(null);
        setSelectedTenantData(null);
        setErrors({});
    };
   
    const handlePageClick = ({ selected }) => {
        const newPage = selected + 1;
        setCurrentPage(newPage);
        fetchTenants(newPage, accountStatus, searchQuery);
    };

    const handleStatusFilterChange = (status) => {
        setStatusFilter(status);
        fetchTenants(1, status, searchQuery); // Re-fetch tenants based on the selected status filter
    };

    const [showLeadOffcanvas, setShowLeadOffcanvas] = useState(false);

    const handleShowLeadDetails = (leadId) => {
        setSelectedTenantId(leadId);
        setShowLeadOffcanvas(true);
    };

    const handleCloseLeadDetails = () => {
        setShowLeadOffcanvas(false);
        setSelectedTenantId(null);
    };
     const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(
                `${backendUrl}/api/tenant-info/import`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                        'Tenant-Origin': origin,
                    },
                }
            );

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: response.data.message || ` Imported successfully!`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });

            // Refresh the list after import
            setTimeout(() => window.location.reload(), 1000);

            // Clear the file input
            event.target.value = '';

        } catch (error) {
            console.error('Import error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: error.response?.data?.errors || error.response?.errors || `Failed to import instance information`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
            event.target.value = "";

        } finally {
        }
    };

    // Export Functions
    const handleExport = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(
                `${backendUrl}/api/tenant-info/export`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    responseType: 'blob', // Important for file download
                }
            );

            // Create blob link and download
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Get filename from response headers or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = `tenant_${new Date().toISOString().split('T')[0]}.xlsx`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (filenameMatch.length === 2) {
                    filename = filenameMatch[1];
                }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: `Exported successfully!`,
                timer: 2000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });

        } catch (error) {
            console.error('Export error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: `Failed to export`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        } finally {
        }
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}

                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Tenants</h4>
                                <div className="page-title-right">

                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Instance Table */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    {/* <div className="d-flex justify-content-end mb-3"> */}
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>
                                         <div className="d-flex align-items-center gap-2">
                                            {/* Export Button */}
                                            <button
                                                type="button"
                                                className="btn btn-light border"
                                                onClick={handleExport}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Export"
                                            >
                                                <i className="mdi mdi-file-excel text-success"></i>
                                            </button>

                                            {/* Import Button */}
                                            <input
                                                type="file"
                                                accept=".xlsx, .xls"
                                                id="importLeadsFile"
                                                onChange={handleImport}
                                                style={{ display: "none" }}
                                            />
                                            <label
                                                htmlFor="importLeadsFile"
                                                className="btn btn-light border mb-0"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Import"
                                            >
                                                <i className="mdi mdi-upload text-primary"></i>
                                            </label>

                                           
                                            <WithCreatePermission>
                                                <button
                                                    type="button"
                                                    className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"
                                                    onClick={() => handleShowModal()}
                                                    title="Add Tenant"
                                                    style={{ width: '40px', height: '40px' }}
                                                >
                                                    <i className="mdi mdi-plus"></i>
                                                </button>
                                            </WithCreatePermission>
                                        </div>
                                    </div>


                                    <div className="table-responsive">
                                        <table className="table align-middle table-nowrap table-check table-list">

                                            <thead className="table-light">
                                                <tr>
                                                    <th style={{ width: '20px' }} className="align-middle">
                                                        <div className="form-check font-size-16">
                                                            <input className="form-check-input" type="checkbox" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">#</th>
                                                    <th className="align-middle">Name</th>
                                                    <th className="align-middle">Instance</th>

                                                    <th className="align-middle">Contract Type</th>
                                                    <th className="align-middle">
                                                        Account Status
                                                        <div className="dropdown d-inline-block">
                                                            <button
                                                                className="btn btn-link"
                                                                type="button"
                                                                id="filterDropdown"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                <i className="bx bx-filter-alt" style={{ color: "grey" }}></i>
                                                            </button>
                                                            <ul className="dropdown-menu" aria-labelledby="filterDropdown">
                                                                <li><button className="dropdown-item" onClick={() => handleStatusFilterChange('all')}>All</button></li>
                                                                <li><button className="dropdown-item" onClick={() => handleStatusFilterChange('active')}>Active</button></li>
                                                                <li><button className="dropdown-item" onClick={() => handleStatusFilterChange('deactivated')}>Deactivated</button></li>
                                                                <li><button className="dropdown-item" onClick={() => handleStatusFilterChange('suspended')}>Suspended</button></li>
                                                            </ul>
                                                        </div>
                                                    </th>


                                                    <th className="align-middle">AMC Startdate</th>
                                                    {/* <th>IPs</th> */}
                                                    <th className="align-middle">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tenants.length > 0 ? (
                                                    tenants.map((tenant, index) => (
                                                        <tr key={tenant.id}>
                                                            <td>
                                                                <div className="form-check font-size-16">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`instanceCheck${index}`}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={`instanceCheck${index}`}
                                                                    ></label>
                                                                </div>
                                                            </td>
                                                            <td>{index + 1}</td>
                                                            <td>
                                                                <button
                                                                    onClick={() => handleShowLeadDetails(tenant.id)} // Pass lead ID
                                                                    className="dropdown-item"
                                                                >
                                                                    {tenant.name}
                                                                </button>
                                                            </td>
                                                            <td>{tenant.instance?.setup_name}</td>
                                                            <td>

                                                                    {tenant.contract_type}
                                                            </td>
                                                            <td>{tenant.account_status}</td>
                                                            {/* <td>{tenant.status_note}</td> */}
                                                            {/* <td>{tenant.login}</td> */}
                                                            <td>{tenant.anc_start_date}</td>
                                                            {/* <td>{tenant.ips}</td> */}
                                                            <td>
                                                                <div className="dropdown">
                                                                    <i
                                                                        className="mdi mdi-dots-horizontal font-size-18"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                        style={{ cursor: 'pointer' }}
                                                                    ></i>
                                                                    <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                        <li>
                                                                           <button
                                                                    onClick={() => handleShowLeadDetails(tenant.id)} // Pass lead ID
                                                                    className="dropdown-item"
                                                                >
                                                                    View Details
                                                                </button>
                                                                        </li>
                                                                        <li>
                                                                            <WithEditPermission>
                                                                                <button
                                                                                    className="dropdown-item"
                                                                                    onClick={() => handleShowModal(tenant.id)}
                                                                                >
                                                                                    Edit
                                                                                </button>
                                                                            </WithEditPermission>
                                                                        </li>
                                                                        <li>
                                                                            <WithDeletePermission>
                                                                                <button
                                                                                    className="dropdown-item"
                                                                                    onClick={() => deleteTenant(tenant.id)}
                                                                                >
                                                                                    Delete
                                                                                </button>
                                                                            </WithDeletePermission>
                                                                        </li>
                                                                        {/* <li>
                                            <Link
                                                to={`/licenses?tenant_id=${tenant.id}&instance_id=${tenant.instance ? tenant.instance.id : ''}`}
                                                className="dropdown-item"
                                            >
                                                License
                                            </Link>
                                        </li> */}
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="8">No tenants available</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>

                                        <div className="d-flex justify-content-end pagination-sm">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                pageCount={pageCount}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={3}
                                                onPageChange={handlePageClick}
                                                containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link'}
                                                previousClassName={'page-item previous'}
                                                previousLinkClassName={'page-link'}
                                                nextClassName={'page-item next'}
                                                nextLinkClassName={'page-link'}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link'}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <TenantModal
                        showModal={showModal}
                        handleClose={handleCloseModal}
                        tenantId={selectedTenantId}
                        tenantData={selectedTenantData}
                        addTenant={addTenant}
                        editTenant={editTenant}
                        instances={instances}
                        errors={errors}
                        setErrors={setErrors}
                        industries={industries}
                        fetchIndustries={fetchIndustries}
                    />

                    <TenantDetails
                        show={showLeadOffcanvas}
                        onHide={handleCloseLeadDetails}
                        tenantId={selectedTenantId}
                    // onOrganisationUpdate={fetchOrganisation} // Pass refresh function if needed
                    />
                </div>
            </div>
        </div>

    );
};
export default AllTenantList;








